import React from 'react';

import './Badrequest.component.css';

export default class Badrequest extends React.Component {
    render() {
        return (
            <div className="badrequest-container">
                We encountered a problem.  Please go back to the email and re-click on the button to try again.  If this keeps happening use the table in email reply.
            </div>
        );
    }
}